const STORAGE_KEY = 'transition-perf'

/** Set to `true` to always log transition perf. */
export const TRANSITION_PERF = false

/**
 * Enable at runtime (no rebuild):
 *   localStorage.setItem('transition-perf', '1'); location.reload()
 * Disable:
 *   localStorage.removeItem('transition-perf'); location.reload()
 */
export const isTransitionPerfEnabled = () =>
  TRANSITION_PERF ||
  (typeof window !== 'undefined' && window.__TRANSITION_PERF__ === true) ||
  (() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1'
    } catch {
      return false
    }
  })()

export const perfTime = (step) => {
  if (!isTransitionPerfEnabled()) return () => {}

  const start = performance.now()
  return (detail) => {
    const ms = Number((performance.now() - start).toFixed(2))
    if (detail !== undefined) {
      console.log(`[transition perf] ${step}: ${ms.toFixed(2)}ms`, detail)
    } else {
      console.log(`[transition perf] ${step}: ${ms.toFixed(2)}ms`)
    }
    return ms
  }
}

let lastTransitionOutDoneAt = 0

export const perfMarkTransitionOutDone = () => {
  if (!isTransitionPerfEnabled()) return
  lastTransitionOutDoneAt = performance.now()
}

export const getLastFetchMs = () => {
  if (!lastTransitionOutDoneAt) return null
  return Number((performance.now() - lastTransitionOutDoneAt).toFixed(2))
}

export const perfLog = (step, detail) => {
  if (!isTransitionPerfEnabled()) return

  if (detail !== undefined) {
    console.log(`[transition perf] ${step}`, detail)
  } else {
    console.log(`[transition perf] ${step}`)
  }
}

export const bindHighwayPerf = (H, { wasPrefetched, getPrefetchDuration } = {}) => {
  if (!isTransitionPerfEnabled()) return

  let navStart = 0

  H.on('NAVIGATE_OUT', ({ location }) => {
    navStart = performance.now()
    lastTransitionOutDoneAt = 0
    const href = location?.href
    const highwayCacheHit = H.cache?.has(href) ?? false

    perfLog('→ NAVIGATE_OUT (fade-out starts)', {
      href,
      highwayCacheHit
    })
  })

  H.on('NAVIGATE_IN', ({ location }) => {
    const href = location?.href
    const htmlFetchMs = getLastFetchMs()

    perfLog('→ NAVIGATE_IN (new page ready, fade-in starts)', {
      href,
      // ~0ms when Highway cache hit; ~server RTT when cold fetch
      htmlFetchMs,
      wasPrefetched: wasPrefetched?.(href) ?? false,
      prefetchMs: getPrefetchDuration?.(href) ?? null
    })
  })

  H.on('NAVIGATE_END', ({ location }) => {
    const ms = (performance.now() - navStart).toFixed(2)
    console.log(`[transition perf] ← NAVIGATE_END (full navigation): ${ms}ms`, {
      href: location?.href
    })
  })
}
